import {OrderCard} from 'app/features/orders/componentsv1'
import {SummaryItem} from 'app/features/orders/componentsv1/shared'
import {FC, useMemo} from 'react'
import sumBy from 'lodash/sumBy'

interface Props {
  subtotalPrice: number
  items: any[]
  title: string | any
  children: React.ReactNode
  footer?: any
  isBetween?: boolean
}

export const EditPaymentSummary: FC<Props> = ({
  subtotalPrice,
  items,
  title,
  children,
  footer,
  isBetween,
}) => {
  const quantity = useMemo(() => {
    return sumBy(items, (item: any) => {
      if (item && item.quantity > 0) {
        return parseInt(item.quantity)
      }
      return 0
    })
  }, [items])

  return (
    <OrderCard title={title} className='py-5' isCustomFooter={footer}>
      <SummaryItem
        title={
          <div className='d-flex align-items-center gap-20'>
            <div className='ms-9'></div>
            <span className='text-dark'>Subtotal</span>
          </div>
        }
        value={subtotalPrice}
        isBetween={isBetween}
      >
        {!isBetween && quantity > 0 && (
          <span className='text-muted'>
            {quantity} item{quantity > 1 && 's'}
          </span>
        )}
      </SummaryItem>
      {children}
    </OrderCard>
  )
}

export default EditPaymentSummary
